
import { buildForm } from './forms';
import $ from 'jquery';

$(document).ready(function () {
	buildForm(document);
});